import React from 'react';
import PropTypes from 'prop-types';
import styles from './Details.module.scss';
import Label from 'shared/components/label';
import FormikTextField from 'src/components/FormikTextField';
import {map, startCase} from 'lodash';

const shortTextDetailInputFields = [
  {type: 'number', name: 'minimumWords', placeholder: 'eg 100'},
  {type: 'number', name: 'minimumCharacters', placeholder: 'eg 200'},
];

const longTextDetailInputFields = shortTextDetailInputFields.concat({
  type: 'number',
  name: 'minimumSentences',
  placeholder: 'eg 3',
});

const numberDetailInputFields = [
  {type: 'number', name: 'minimumNumber', placeholder: 'eg 10'},
  {type: 'number', name: 'maximumNumber', placeholder: 'eg 10'},
];

const propTypes = {
  index: PropTypes.number,
  detail: PropTypes.object,
};

const DetailValidationFields = (props) => {
  const {detail, index} = props;
  const fieldsToInputs = {
    'TimeSensitiveItemType::ShortTextDetail': shortTextDetailInputFields,
    'TimeSensitiveItemType::LongTextDetail': longTextDetailInputFields,
    'TimeSensitiveItemType:NumberDetail': numberDetailInputFields,
  };

  return (
    <>
      <div className={styles.optionalTitle}>Optional:</div>
      {map(fieldsToInputs[detail._type], (field) => (
        <div className={styles.dateSelector} key={field.name}>
          <Label>
            {`${startCase(field.name)}? (default = 0)`}
            <FormikTextField
              name={`details[${index}].${field.name}`}
              type={field.type}
              placeholder={field.placeholder}
            />
          </Label>
        </div>
      ))}
    </>
  );
};

DetailValidationFields.propTypes = propTypes;
export default DetailValidationFields;
